import React, { useMemo } from 'react';

import { Box, type BoxProps } from '@frontend/legacy-components';

import { CASCADER_SUBCOMPONENT_NAMES } from '../consts';
import { useCascaderState, useCascaderComponentsContext } from '../context';
import type { CascaderOption, CascaderCommonProps } from '../types';

export interface SubmenuWrapperProps<OptionType extends CascaderOption>
  extends InternalSubmenuWrapperProps {
  getCommonProps: () => CascaderCommonProps<OptionType>;
}

interface InternalSubmenuWrapperProps extends BoxProps {
  submenuRef?: React.Ref<HTMLDivElement>;
}

export const InternalSubmenuWrapper = <OptionType extends CascaderOption>({
  submenuRef,
  children,
  ...rest
}: InternalSubmenuWrapperProps) => {
  const { cascaderStyles, getCommonProps } = useCascaderState<OptionType>();
  const { getComponent } = useCascaderComponentsContext<OptionType>();
  const CustomSubmenuWrapper = useMemo(
    () => getComponent(CASCADER_SUBCOMPONENT_NAMES.SUBMENU_WRAPPER),
    [getComponent],
  );

  return (
    <CustomSubmenuWrapper
      submenuRef={submenuRef}
      getCommonProps={getCommonProps}
      __css={cascaderStyles.submenuWrapper}
      {...rest}
      className="cascader-submenu-wrapper"
    >
      {children}
    </CustomSubmenuWrapper>
  );
};

export const SubmenuWrapper = <OptionType extends CascaderOption>({
  submenuRef,
  children,
  getCommonProps: _,
  ...rest
}: SubmenuWrapperProps<OptionType>) => {
  return (
    <Box ref={submenuRef} {...rest}>
      {children}
    </Box>
  );
};
